import * as React from 'react';
import styled from 'styled-components';

export interface LinkProps {
    children?: React.ReactNode;
    className?: string;
    disabled?: boolean;
    inline?: boolean;
    onClick?(event?: React.MouseEvent<HTMLAnchorElement>): void;
    target?: string;
    url?: string;
}

const Link: React.FC<LinkProps> = ({
    children,
    className = ',',
    disabled = false,
    inline = false,
    onClick,
    target,
    url = ''
}): JSX.Element => {
    const handleClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
        if (disabled) {
            return;
        }

        if (onClick) {
            onClick(event);
        }
    };

    return (
        <Root className={ className }
            disabled={ disabled }
            href={ url }
            inline={ inline }
            onClick={ handleClick }
            target={ target }
        >
            { children }
        </Root>
    );
};

const Root = styled.a<LinkProps>`
    color: ${ ({ theme }) => theme.semanticColor.primary };
    text-decoration: ${ ({ inline }) => (inline ? 'underline' : 'none') };

    ${ ({ disabled, theme }) =>
        (disabled
            ? `
        color: ${ theme.semanticColor.textDisabled };
        text-decoration: none!important;
    `
            : `
        cursor: pointer;
    `) }

    &:hover {
        text-decoration: underline;
    }

    &:focus {
        text-decoration: underline;
        text-decoration-style: dotted;
    }

    &:active {
        ${ ({ inline, disabled, theme }) => `
            color: ${ theme.semanticColor.textPrimary };
            text-decoration: ${ inline || disabled ? 'none!important' : 'underline' };
        ` }
    }
`;

export default Link;
